import { render, staticRenderFns } from "./order-infos.vue?vue&type=template&id=304eb1e0&scoped=true"
import script from "./order-infos.vue?vue&type=script&lang=js"
export * from "./order-infos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304eb1e0",
  null
  
)

export default component.exports